var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.208 17.332a2.173 2.173 0 0 0 2.167-2.166 2.173 2.173 0 0 0-2.167-2.167 2.173 2.173 0 0 0-2.166 2.167c0 1.191.975 2.166 2.166 2.166Zm6.5-9.75h-1.083V5.417A5.419 5.419 0 0 0 9.208 0a5.418 5.418 0 0 0-5.416 5.416H5.85a3.361 3.361 0 0 1 3.358-3.358 3.361 3.361 0 0 1 3.359 3.358v2.167H2.708A2.173 2.173 0 0 0 .542 9.749v10.833c0 1.192.975 2.167 2.166 2.167h13a2.173 2.173 0 0 0 2.167-2.167V9.75a2.173 2.173 0 0 0-2.167-2.166Zm0 13h-13V9.75h13v10.833Z",
    fill: "#fff"
  })));
};
export default SvgUnlock;